export default {
    noun: 'Sustantivo',
    article: 'Articulo',
    adjective: 'Adjetivo',
    pronoun: 'Pronombre',
    verb: 'Verbo',
    adverb: 'Adverbio',
    preposition: 'Preposición',
    conjunction: 'Conjunción',
    interjection: 'Interjección',
    numeral: 'Número'
}
